import { Box } from "@mui/material";
import { useTenantTranslation } from "hooks/formatters";
import { useStringQueryParamState } from "hooks/useStringQueryParamState";

import { RequireFeatureFlags } from "src/routes/authentication";
import { ToggleSelector } from "../ToggleSelector";
import { ConsumptionTabTimelineProvider } from "./ConsumptionTabTimelineContext";
import { ConsumptionTabTimeline } from "./ConsumptionTimeline";
import { ConsumptionTabProjectionProvider } from "./ConsumptionTabProjectionContext";
import { ConsumptionProjection } from "./ConsumptionProjection";

type ConsumptionView = "timeline" | "projection";

export const ConsumptionTabContent = () => {
  const { t } = useTenantTranslation();
  const [selectedView, setSelectedView] =
    useStringQueryParamState<ConsumptionView>("view", "timeline");

  const getContent = (selectedView: ConsumptionView) => {
    switch (selectedView) {
      case "timeline":
        return <ConsumptionTabTimeline />;
      case "projection":
        return <ConsumptionProjection />;
    }
  };

  return (
    <>
      <RequireFeatureFlags
        featureFlags={["strategy_dashboard_consumption_projection"]}
      >
        <Box sx={{ mt: 2 }}>
          <ToggleSelector<ConsumptionView>
            selectedValue={selectedView}
            setSelectedValue={setSelectedView}
            availableValueLabels={{
              timeline: t("timeline"),
              projection: t("projections"),
            }}
          />
        </Box>
      </RequireFeatureFlags>
      {getContent(selectedView)}
    </>
  );
};

export const ConsumptionTab = () => (
  <ConsumptionTabTimelineProvider>
    <ConsumptionTabProjectionProvider>
      <ConsumptionTabContent />
    </ConsumptionTabProjectionProvider>
  </ConsumptionTabTimelineProvider>
);
